<template>
  <Modal v-model="showModal" :transition-names="['none', 'none']" width="380" lock-scroll scrollable draggable
    :closable="false" :mask="false" :maskClosable="false">
    <p slot="header" style="color: #f60; text-align: center">
      <Icon type="md-information-circled"></Icon>
      <span>{{ title }}</span>
    </p>
    <div>
      <Input v-model="floorName" placeholder="请输入关键词" clearable style="width: 100%" @on-change="Search(floorName)" />
      <Table height="400" style="margin-top: 10px" :columns="columns" :data="data" stripe highlight-row
        @on-row-click="rowClick"></Table>
    </div>
  </Modal>
</template>
<script>
import { Modal, Input, Table } from 'view-design'
export default {
  components: {
    Modal,
    Input,
    Table,
  },
  data() {
    return {
      showModal: false,
      title: '楼层选择',
      floorName: '',
      workType: 1,
      allData: [],
      data: [],
      columns: [
        {
          title: '楼层名称',
          minWidth: 170,
          align: 'left',
          key: 'floorName',
        },
      ],
    }
  },
  async created() {
    await this.loadData()
  },
  mounted() { },
  methods: {
    open() {
      this.showModal = true
    },
    close() {
      this.showModal = false
    },
    selectText(val) {
      this.getText(val)
        // 选择文本
      this.$emit('func', val)
    },
    rowClick(row) {
      // 点击选择行
      this.selectText(row.floorName)
    },
    async loadData() {
      let q = {}
      let res = await $utils.api.load('/admin/system/floor/list', q)
      if (res) {
        if (res.code > 0) {
          let data = res.rows
          let list = data || []
          this.allData = list
          this.data = list
        }
      }
    },
    Search(floorName) {
      let keyword = this.floorName
      let allData = this.allData
      let newData = []
      for (let index = 0; index < allData.length; index++) {
        let item = allData[index] || {}
        let descrOld = item.floorName
        if (descrOld.indexOf(keyword) != -1) {
          newData.push(item)
          this.data = newData
        }
      }
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .ivu-modal-content {
  position: fixed;
  left: auto;
  right: 10px;
}
</style>
